import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SearchEntitiesBatchRequest } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/v2/SearchEntities.pb'
import { SearchEntitiesBatchResponse } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/v2/SearchEntities.pb'

export const searchEntitiesBatch = (request: SearchEntitiesBatchRequest, options?: CashRequestOptions) =>
  post<SearchEntitiesBatchRequest, SearchEntitiesBatchResponse>('/2.0/cash/search-entities-batch', request, {
    ...options,
    rejectOnError: true,
  })
